module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/upgrade-to-2-6.vue");


//////////////////
// WEBPACK FOOTER
// ./en/upgrade-to-2.md
// module id = 621
// module chunks = 388